
/**
 * 解析表格数据
 * @param {Array} apiReturnData 
 */
export const parseTableData = (apiReturnData) => {
    let paramData = []
    for (let item of apiReturnData) {
        paramData.push({
            date: item.createDay,
            inMoney: Number(item.inMoney) || 0,
            inCount: Number(item.inCount) || 0,
            outMoney: Number(item.outMoney) || 0,
            outCount: Number(item.outCount) || 0,
        })
    }
    // 合计块
    let totalInMoney = 0, totalInCount = 0, totalOutMoney = 0, totalOutCount = 0
    for (let item of paramData) {
        totalInMoney += item.inMoney
        totalInCount += item.inCount
        totalOutMoney += item.outMoney
        totalOutCount += item.outCount
    }
    paramData.push({
        date: '总计',
        inMoney: totalInMoney,
        inCount: totalInCount,
        outMoney: totalOutMoney,
        outCount: totalOutCount,
    })
    return createTableData(paramData)
}

const createTableData = (paramData) => {
    let tableData = []
    for (let param of paramData) {
        let isTotal = (param.date === '总计')
        let tdClass = isTotal ? 'qa-td-total' : 'qa-td-normal'
        let tr = [
            { value: param.date, colspan: 1, rowspan: 1, class: tdClass },
            { value: param.inCount, colspan: 1, rowspan: 1, class: tdClass },
            { value: (param.inMoney / 100).toFixed(2), colspan: 1, rowspan: 1, class: tdClass },
            { value: param.outCount, colspan: 1, rowspan: 1, class: tdClass },
            { value: (param.outMoney / 100).toFixed(2), colspan: 1, rowspan: 1, class: tdClass },
        ]
        tableData.push({ tr })
    }
    return tableData
}
